export default {
    toastText: "Copié!",
};
